export const SUBSCRIBE_BUTTON = 'product_autoreplenish_subscribe_button';
export const PRODUCT_AUTO_REPLENISH = 'product_auto_replenish';
